import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class AtualizacoesService {

  private baseUrlService: string;
  private valorSujeito = new BehaviorSubject<string>('');

  constructor(public httpClient: HttpClient, router: Router) {
    this.baseUrlService = environment.URL_API;
  }


  protected getURL(): string {
    return '';
  }

  getUsername(): string {
    return JSON.parse(sessionStorage.getItem('currentUser')).username;
  }
  atualizarValor(novoValor: string) {
    this.valorSujeito.next(novoValor);
  }

  obterValor() {
    return this.valorSujeito.asObservable();
  }

  public verificaAtualizacoesGet(page, size): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/updatePortal'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('page', page)
        .set('size', size)
    });
  }

  public agendamento(): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/updatePortal/versao/disponivel'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')) ?
          JSON.parse(sessionStorage.getItem('currentUser')).token :
          null

      }),
    });
  }

  public atualizarVersao(id_update_portal: number, usuario: string, data_selecionada: string): Observable<any> {
    const url = `${this.baseUrlService}/updatePortal/atualizacao`;
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': currentUser.token
      }),
      params: new HttpParams()
        .set('id_update_portal', id_update_portal.toString())
        .set('usuario', usuario)
        .set('data_selecionada', data_selecionada)
    };

    return this.httpClient.put<any>(url, {}, httpOptions);
  }

}
